//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { rinkPolicyQueryPageList, rinkoUpdateStatus } from '@/api/rinko';
import { getChilComList, getProductList, getCompanyList } from '@/api/baseDate';
export default {
  name: 'Policysearch',
  data: function data() {
    return {
      insuranceCompanyCode: '',
      insuranceCompanyName: '',
      currentPage4: 4,
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: [],
      options2: [],
      options3: [{
        value: '1',
        label: '人身意外伤害保险'
      }, {
        value: '2',
        label: '出口产品责任保险'
      }, {
        value: '3',
        label: '关税保证保险'
      }, {
        value: '4',
        label: '货物运输保险'
      }, {
        value: '5',
        label: '企业财产保险'
      }, {
        value: '6',
        label: '安全生产责任保险'
      }, {
        value: '7',
        label: '出口贸易信用保险（短期）'
      }],
      options: [],
      user_type: '',
      inForm: {
        proposalNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        proposalStatus: '',
        companyCode: '',
        companyName: '',
        productCode: '',
        productName: '',
        startDate: '',
        endDate: '',
        user_type: '',
        updateBy: '',
        policyNo: '',
        // 状态
        options: [{
          value: '1',
          label: '已生成投保单'
        }, {
          value: '2',
          label: '已生成保单'
        }, {
          value: '3',
          label: '已作废'
        }]
      },
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      rules: {
        insuranceCompanyCode: [{
          required: false,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        productCode: [{
          required: false,
          message: '请选择产品名称',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      options_insuranceCompanyName: [{
        value: 'IC0030',
        label: '中国太平洋财产保险股份有限公司上海分公司'
      }],
      options_companyName: []
    };
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  mounted: function mounted() {},
  created: function created() {
    this.Init_get();
    var list = this.$store.state.user.userinfo.insuranceCompanyList || []; // console.log(list,'保险公司数组')

    var companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || '';
    this.get_select(list, companyCode); // 默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label || '';
    this.restaurants = this.loadAll();
  },
  methods: {
    getPath: function getPath() {
      this.Init_get();
    },
    // 初始化
    Init_get: function Init_get() {
      var _this = this;

      var data = this.inForm;
      this.loading = true;
      data.insuranceCompanyName = this.inForm.insuranceCompanyName;
      data.insuranceCompanyCode = this.inForm.insuranceCompanyCode;
      data.companyName = this.inForm.companyName;
      data.companyCode = this.inForm.companyCode;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize; // console.log(data)
      // console.log(this.inForm.startDate)

      rinkPolicyQueryPageList(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode'));

        if (res.content != null) {
          debugger; // 0-用户 1-保险公司

          for (var i = 0; i < res.content.length; i++) {
            if (orgCode != null && orgCode != '') {
              if (orgCode == res.content[i].identifyNumber) {
                console.log(res.content[i].identifyNumber, i);
                res.content[i].user_type = '0';
              }
            } else {
              res.content[i].user_type = '1';
            }
          }
        }

        console.log(res);
        _this.tableData = res.content;
        _this.total = res.totalCount;
        _this.loading = false;
      });
    },
    // ------下拉信息
    get_select: function get_select(list, code) {
      debugger;
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label; // 查询保险公司下的分支机构

      this.companyqueryAll_fun(val); // this.riskqueryAll_fun(val)
    },
    // 分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    // 状态
    proposalStatus_ch: function proposalStatus_ch(val) {
      var obj = {};
      obj = this.options_proposalStatus.find(function (item) {
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.proposalStatus = obj.label;
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this2 = this;

      this.options_companyName = [];
      var data = {
        insuranceCompanyCode: code
      };
      debugger;
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          debugger;
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this2.options_companyName.push(obj);
        }
      });
    },
    // 产品名称 --险种
    productCode_ch: function productCode_ch(val) {
      debugger;
      var obj = {};
      obj = this.options3.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.productName = obj.label;
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this3 = this;

      var data = {}; //  去除首尾空格

      this.inForm.policyNo = this.inForm.policyNo.trim();
      this.inForm.updateBy = this.inForm.updateBy.trim();
      this.inForm.proposalNo = this.inForm.proposalNo.trim();

      if (this.inForm.startDate && this.inForm.endDate) {
        if (this.inForm.startDate > this.inForm.endDate) {
          this.$message({
            type: 'warning',
            message: '起保起期不能晚于起保止期'
          });
          return false;
        } else {
          this.$refs[formName].validate(function (valid) {
            if (valid) {
              _this3.pageNo = 1;

              _this3.Init_get();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        }
      } else {
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this3.pageNo = 1;

            _this3.Init_get();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        proposalNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        companyCode: '',
        companyName: '',
        productCode: '',
        productName: '',
        startDate: '',
        endDate: '',
        updateBy: '',
        policyNo: ''
      }; // 清空分支机构

      this.options_companyName = [];
      this.options2 = [];
    },
    // 查看
    searchQuery: function searchQuery(type, data) {
      console.log(data);
      var params = {
        type: type,
        proposalNo: data.row.proposalNo,
        applicationNo: data.row.applicationNo
      };
      this.$router.push({
        path: "/rinkoPlatPolicyManage/policyInfoBuLu/".concat(params.type, "/").concat(params.proposalNo, "/").concat(params.applicationNo)
      });
    },
    // 转为有效保单
    download: function download(data) {
      this.$router.push({
        path: '/rinkoPlatPolicyManage/policyInfoBuLu?applicationNo=' + data.applicationNo + '&proposalNo=' + data.proposalNo
      });
    },
    // 作废
    cancellation: function cancellation(val) {
      var _this4 = this;

      this.loading = true;
      this.$confirm('请确认是否要作废该保单', '提示', {
        confirmButtonText: '确认作废',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          proposalNo: val.proposalNo
        };
        rinkoUpdateStatus(data).then(function (res) {
          if (res.resultCode == '0000') {
            _this4.$message({
              message: res.resultMessage,
              type: 'success'
            });

            _this4.Init_get();
          } else if (res.resultCode == '9999') {
            _this4.$message({
              message: res.resultMessage,
              type: 'error'
            });
          }

          _this4.loading = false;
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消保单作废'
        });

        _this4.loading = false;
      });
    }
  },
  // 支持模糊查询
  loadAll: function loadAll() {
    return [{
      'value': '三全鲜食（北新泾店）',
      'address': '长宁区新渔路144号'
    }, {
      'value': 'Hot honey 首尔炸鸡（仙霞路）',
      'address': '上海市长宁区淞虹路661号'
    }, {
      'value': '新旺角茶餐厅',
      'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'
    }];
  },
  querySearchAsync: function querySearchAsync(queryString, cb) {
    var restaurants = this.restaurants;
    var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(function () {
      cb(results);
    }, 1000 * Math.random());
  },
  createStateFilter: function createStateFilter(queryString) {
    return function (state) {
      return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    };
  },
  handleSelect: function handleSelect(item) {
    console.log(item);
  },
  // 保险公司
  findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
    var _this5 = this;

    //				var plk = {
    //					label:"请选择",
    //					value:""
    //
    //				}
    this.options_insuranceCompanyName = [];

    for (var i = 0; i < list.length; i++) {
      var obj = {};
      obj.value = list[i].insuranceCompanyCode;
      obj.label = list[i].insuranceCompanyName;

      if (!obj.value || !obj.label) {
        this.options_insuranceCompanyName = [];
      } else {
        this.options_insuranceCompanyName.push(obj);
      }
    }

    var data = {
      insuranceCompanyCode: code
    };
    getCompanyList(data).then(function (res) {
      _this5.options_insuranceCompanyName = [];

      for (var i = 0; i < res.length; i++) {
        console.log(res);
        var obj = {};
        obj.value = res[i].insuranceCompanyCode;
        obj.label = res[i].insuranceCompanyName;

        if (!obj.value || !obj.label) {
          _this5.options_insuranceCompanyName = [];
        } else {
          _this5.options_insuranceCompanyName.push(obj);
        }
      }
    });
  },
  // 产品名称
  riskqueryAll_fun: function riskqueryAll_fun(code) {
    var _this6 = this;

    this.options2 = [];
    var data = {
      insuranceCompanyCode: code
    };
    debugger;
    getProductList(data).then(function (res) {
      _this6.options2 = [];
      debugger;

      for (var i = 0; i < res.length; i++) {
        var obj = {};
        obj.value = res[i].productCode;
        obj.label = res[i].productName;

        _this6.options2.push(obj);
      }

      console.log(_this6.options2);
    });
  },
  // 点击保单号查看详情
  view_but: function view_but(type, row) {
    // console.log(row)
    var params = {
      type: type,
      insurancecompanyCode: row.row.insuranceCompanyCode,
      protocolNo: row.row.protocolNo,
      productCode: row.row.riskCode,
      productName: row.row.riskName,
      proposalNo: row.row.proposalNo
    }; // console.log(params.insurancecompanyCode)

    /* this.$router.push({
        path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`
      });*/

    if (row.row.othFlag !== undefined && row.row.othFlag === 'customFlag') {
      // 报关单
      this.$router.push({
        name: 'insuranceentry2',
        params: params
      });
    } else if (row.row.othFlag !== undefined && row.row.othFlag === 'autoCustomFlag') {
      // 报关单自动投保
      this.$router.push({
        name: 'insuranceentry3',
        params: params
      });
    } else {
      // 无报关单
      this.$router.push({
        name: 'insuranceentry1',
        params: params
      });
    }
  }
};